import { TranslateFn, Translations } from '../types'
import { loadTranslations } from './load'
import { createTranslationFn } from './translate'
import { createCookiePolicyLinkTemplate } from '../components'

const createTranslationsContext = (translations: Translations) => ({
  cookie_policy_link: createCookiePolicyLinkTemplate(
    translations.CookieConsentBanner_CookiePolicyLink,
    translations.CookieConsentBanner_Wix_Policy_Link,
    translations.CookieConsentBanner_EditorX_Policy_Link,
  ), // eslint-disable-line
})

export const init = (
  staticsUrl: string,
  language: string,
  callback: (translate: TranslateFn) => void,
): void => {
  loadTranslations(staticsUrl, language, (translations: Translations) => {
    const context = createTranslationsContext(translations)
    const translate: TranslateFn = createTranslationFn(translations, context)
    callback(translate)
  })
}
